import { useRef } from "react";

/**
 * Card wrapper — subtle scale-up + cyan glow on hover. (Tilt + foil shine removed per user.)
 * Kept as a named component for reuse / future restyling.
 */
export default function HoloCard({ children, className = "", testId }) {
  const ref = useRef(null);
  return (
    <div ref={ref} className={`holo-card ${className}`} data-testid={testId}>
      <div className="holo-card-inner">
        {children}
      </div>
    </div>
  );
}
